import $axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "app-constants";
import { RetryAxiosRequestConfig } from "types";

export const AxiosCancelKey = Symbol("axios-cancel-key");

export const cancelInterceptors = [
  (response: AxiosResponse) => response,
  (error: any) => {
    if ($axios.isCancel(error)) {
      return Promise.reject({
        [AxiosCancelKey]: true,
        message: "The endpoint was cancelled",
      });
    }

    if (error.response) {
      // handle errors
    }

    return Promise.reject(error);
  },
] as const;

export const authInterceptor = (config: AxiosRequestConfig) => {
  const authToken = localStorage.getItem(ACCESS_TOKEN_KEY);

  if (!config.headers) config.headers = {};
  if (authToken) config.headers["Authorization"] = `Bearer ${authToken}`;

  return config;
};

type TokenExpiredCode = "token_expired";

/**
 *
 * @param failCallback Called when token is not valid and fails to refresh
 */
export const createRefreshTokenInterceptors = (
  axios: AxiosInstance,
  refreshCall: (refresh: string) => Promise<void>,
  failCallback: () => void,
) =>
  [
    (res: any) => res,
    async (err: AxiosError<{ code: TokenExpiredCode }>) => {
      const originalConfig: RetryAxiosRequestConfig | undefined = err.config;

      // Access Token was expired or invalid
      if (
        originalConfig &&
        !originalConfig?._retry &&
        err?.response?.status === 403 &&
        err?.response?.data?.code === "token_expired"
      ) {
        originalConfig._retry = true;
        const resfreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
        if (resfreshToken)
          try {
            await refreshCall(resfreshToken);
            return axios(originalConfig);
          } catch (_error: any) {
            const error = _error as AxiosError;
            failCallback();

            if (error.response && error.response.data) {
              return Promise.reject(error.response.data);
            }

            return Promise.reject(error);
          }
      }

      return Promise.reject(err);
    },
  ] as const;
